import { type ComponentProps } from 'react';
import cn from 'clsx';
import { type VtourType } from '@pkgs/components/utils/propertyCardUtils';
import { VirtualTourIcon } from '@pkgs/components/assets/icons/small/VirtualTourIcon';
import { VideoTourIcon } from '@pkgs/components/assets/icons/small/VideoTourIcon';
import { MultimediaIcon } from '@pkgs/components/assets/icons/small/MultimediaIcon';

import styles from './VtourIcon.module.css';

export const VtourIconContainer = ({ className, ...props }: ComponentProps<'span'>) => (
  <span className={cn(styles.container, className)} {...props} />
);

const VTOUR_ICONS: Record<VtourType, React.ReactNode> = {
  videoTour: <VideoTourIcon />,
  virtualTour: <VirtualTourIcon />,
  multimedia: <MultimediaIcon />,
};

export const VtourIcon = ({ type }: { type: VtourType }) => {
  return <>{VTOUR_ICONS[type]}</>;
};
